module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.04 9.687\"><g id=\"グループ_532\" data-name=\"グループ 532\" transform=\"translate(-1421.557 -1791.325)\"><path id=\"パス_2078\" data-name=\"パス 2078\" d=\"M1432.847,1801.012a5.345,5.345,0,0,0-5.346-5.346h-4.884\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"1.5\"></path><path id=\"パス_2079\" data-name=\"パス 2079\" d=\"M1426.427,1799.475l-3.81-3.81,3.81-3.81\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"1.5\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/back.svg
// module id = xuLy
// module chunks = 1